import { render, staticRenderFns } from "./ServizioDetail.vue?vue&type=template&id=a7f8ca12&"
import script from "./ServizioDetail.vue?vue&type=script&lang=ts&"
export * from "./ServizioDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports